<template>
  <div
    class="col-12 d-flex align-items-center mt-5 p-20"
  >
      <input
        :class="`img-downloader-${this.type}`"
        type="file"
        multiple
        data-allowed-file-extensions="jpg png jpeg"
        @change="(e) => selectImage(e, type)"
      />
      <div class="ml-2">
        <button
          type="button"
          class="btn btn-primary waves-effect waves-classic btn-save"
          :disabled="disableAddImage"
          @click="addImage(type)"
        >
          {{ $t("button.add") }}
        </button>
        <p class="mt-2">{{ $t("rentals.detail.platforms.vrbo.photos_format") }}</p>
      </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "ImageUploader",
  data() {
    return {
      messages: {
        default: "",
        replace: "Drag and drop or click to replace",
        remove: "Remove",
        error: "Ooops, something wrong happened.",
      },
    };
  },
  props: [
    "addImage",
    "rotateImg",
    "fileSelected",
    "handleLabelChange",
    "amenity",
    "selectImage",
    "type",
    "value",
    "lang",
    "disableAddImage",
  ],
  mounted() {
    if (Vue.config.lang === this.lang) {
      this.setMessages();
    }
  },
  watch: {
    lang: function (val) {
      Vue.config.lang = val;
      this.setMessages();
    },
  },
  methods: {
    setMessages() {
      this.messages.default = this.$t("drag_and_drop_file");
      $(`#${this.type} .img-downloader-${this.type}`).dropify({
        messages: this.messages,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// ImageUploader.vue?711aa9c2